import { HttpInterceptorFn } from '@angular/common/http';

export const languageInterceptor: HttpInterceptorFn = (req, next) => {
  const lang = localStorage.getItem('lang') || 'es';

  const cloned = req.clone({
    setHeaders: { 'Accept-Language': lang },
  });

  return next(cloned);
};
